import { PageView } from '@Core/models/proprietary/page/page.state';

export class AddWizardPageViews {
    static readonly type = '[SubmissionWizard] Add Wizard Page Views';
    constructor(public pageViews: PageView[], public defaultPageLayoutCode: string = null) { }
}

export class SetCurrentWizardPageView {
    static readonly type = '[SubmissionWizard] Set Current Wizard Page View';
    constructor(public viewID: number) { }
}

export class ResetWizardState {
    static readonly type = '[SubmissionWizard] Reset Wizard State';
    constructor() { }
}
